var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1114,
    height: 1115,
    viewBox: "0 0 1114 1115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M701.437 557.951C701.437 637.722 636.77 702.388 557 702.388C477.23 702.388 412.563 637.722 412.563 557.951C412.563 478.181 477.23 413.515 557 413.515C636.77 413.515 701.437 478.181 701.437 557.951Z",
    stroke: "#495BB8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M760.449 557.951C760.449 670.313 669.362 761.4 557 761.4C444.638 761.4 353.551 670.313 353.551 557.951C353.551 445.59 444.638 354.502 557 354.502C669.362 354.502 760.449 445.59 760.449 557.951Z",
    stroke: "#495BB8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M820.223 557.951C820.223 703.325 702.374 821.174 557 821.174C411.626 821.174 293.777 703.325 293.777 557.951C293.777 412.577 411.626 294.729 557 294.729C702.374 294.729 820.223 412.577 820.223 557.951Z",
    stroke: "#495BB8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M879.997 557.951C879.997 736.337 735.386 880.948 557 880.948C378.614 880.948 234.003 736.337 234.003 557.951C234.003 379.565 378.614 234.954 557 234.954C735.386 234.954 879.997 379.565 879.997 557.951Z",
    stroke: "#495BB8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M950.811 557.951C950.811 775.447 774.496 951.762 557 951.762C339.504 951.762 163.188 775.447 163.188 557.951C163.188 340.455 339.504 164.14 557 164.14C774.496 164.14 950.811 340.455 950.811 557.951Z",
    stroke: "#495BB8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1030.76 557.951C1030.76 819.603 818.652 1031.71 557 1031.71C295.347 1031.71 83.2363 819.603 83.2363 557.951C83.2363 296.299 295.347 84.1877 557 84.1877C818.652 84.1877 1030.76 296.299 1030.76 557.951Z",
    stroke: "#495BB8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 557,
    cy: 557.951,
    r: 556,
    stroke: "#495BB8",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.bf8ad220855325f6b6c6010e5f8aa9e3.svg";
export { ForwardRef as ReactComponent };